<template src="./template.html"></template>

<script>
export default {
  name: "HomeTopCarousel",
  data() {
    return {
      images_data: [
        {
          id: 1,
          image: "/img/carousel/mainimage_02_pc.jpg"
        },
        {
          id: 2,
          image: "/img/carousel/mainimage_03_pc.jpg"
        },
        {
          id: 3,
          image: "/img/carousel/mainimage_04_pc.jpg"
        },
        {
          id: 4,
          image: "/img/carousel/mainimage_05_pc.jpg"
        },
        {
          id: 5,
          image: "/img/carousel/mainimage_06_pc.jpg"
        }
      ],
      active_image: 0,
      out_image: 1,
      auto_method: null
    }
  },
  created() {
    this.auto_method = setInterval(this.ImageInterval, 8000);
  },
  methods: {
    ChangeImage(val) {
      if (val != this.active_image) {
        this.out_image = this.active_image
        this.active_image = val
        clearInterval(this.auto_method)
        this.auto_method = setInterval(this.ImageInterval, 8000);
      }
    },
    ImageInterval() {
      this.active_image == this.images_data.length - 1 ? (this.active_image = 0, this.out_image = this.images_data.length - 1) : (this.active_image += 1, this.out_image = this.active_image - 1)
    }
  }
}
</script>